// Bridges Clerk's React-hook token accessor into the non-React `api.ts`
// module. `api.ts` is called from React Query mutations/queries and from
// EventSource setup — neither of which have a stable way to call
// `useAuth()`. The ClerkTokenBridge component (mounted once near the
// root) registers Clerk's `getToken` via `setTokenGetter`, and every
// call to `fetchAuthToken()` afterwards returns a fresh session JWT.
//
// Session JWTs rotate ~every 60s. Clerk's getToken() handles refresh
// automatically, so we can just call it on every request without
// caching — the SDK does caching internally.

type TokenGetter = () => Promise<string | null>;

let tokenGetter: TokenGetter | null = null;

export function setTokenGetter(fn: TokenGetter): void {
  tokenGetter = fn;
}

export async function fetchAuthToken(): Promise<string | null> {
  if (!tokenGetter) return null;
  try {
    return await tokenGetter();
  } catch {
    return null;
  }
}
